import React, { useState } from 'react'
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { compose } from "redux"

import Notification from './components/Notification.jsx'
import HomeBanner from "./components/HomeBanner"

import {
  setUserLocation,
  addUserData,
  setOrderScreen,
  setFormattedAddress,
  setNotificationData,
  setUserData
} from '../../redux/actions'

import translation from '../../translations/FirstOrderScreen'
import Number from '../../components/numpad/Number'
import Api from '../../utils/api/Api'
import { userCreateGuestSession } from '../../utils/helpers'
import { Button } from '../../components/refectored/Button'
import { formatDst } from '../../mixin/date'
import Grid from '@material-ui/core/Grid'

const FirstOrderScreen = props => {
  const { notification } = props;
  // const
  return (
    <main className="order-block-body order-block-body-grid">
      {notification.status && <Notification />}
      <CheckLocationInputs {...props} />
    </main>
  )
}

const ShowServicePoint = ({ point }) => {
  return (
    <div className="service-point-info service-point-show">
      <div className="service-point-company">{ point.company }</div>
      <div className="service-point-address">{ point.addressLine }</div>
    </div>
  )
}

const ShowError = ({error}) => {
  return (
    <div className="service-point-info service-point-error">
      { error }
    </div>
  )
}

const ShowCollection = ({collection}) => {
  const lang = localStorage.getItem('lang')

  if (!collection.order) {
    return (
      <div className="service-point-info collection-info">
        { translation.orderCollectionInProcess(collection)[lang] }
      </div>
    )
  }

  return (
    <>
      <div className="service-point-info order-pickup-date">
        <div className="block-title">{ translation.pickupDate[lang] }</div>
        <div className="pickup-date">{ formatDst(collection.order.pickupTime, 'dddd DD MMMM') }</div>
      </div>
      <div className="service-point-info order-pickup-time">
        <div className="block-title">{translation.pickupTime[lang]}</div>
        <div>{translation.between[lang]} {`${formatDst(collection.order.frames.pickup.from, 'HH:mm')} - ${formatDst(collection.order.frames.pickup.to, 'HH:mm')}`}</div>
      </div>
      <div className="service-point-info order-contact" dangerouslySetInnerHTML={{__html: translation.orderContact[lang]}} />
    </>
  )
}

const CheckLocationInputs = () => {
  const lang = localStorage.getItem('lang')
  const [state, setState] = useState({
    showNumpad: true,
    servicePoint: null,
    code: null,
    error: null,
    variation: 1,
    loading: false,
    collection: null,
    submitting: false,
  })

  const onChange = (value) => {
    if (4 === value.length) {
      updateState({showNumpad: false})

      loadServicePoint(value)
    }
  }

  const loadServicePoint = (value) => {
    updateState({loading: true})

    Api.fetchServicePoint(value).then(({ data }) => {
      updateState({
        servicePoint: data,
        showNumpad: false,
        error: null,
        code: value,
        loading: false,
      })
    }).catch(async () => {
      updateState({
        servicePoint: null,
        showNumpad: false,
        error: translation.locationNotFound[lang],
        code: null,
        loading: false,
      })
    })
  }

  const clear = (e) => {
    e.preventDefault()

    updateState({
      showNumpad: true,
      servicePoint: null,
      error: null,
      code: null,
      variation: state.variation + 1,
      loading: false,
      submitting: false,
      collection: null,
    })
  }

  const updateState = (newState) => {
    const oldState = {...state}

    setState({...oldState, ...newState})
  }

  const placeOrder = async () => {
    updateState({submitting: true})

    await userCreateGuestSession()

    Api.placeCollectionOrder(state.code).then(({ data }) => {
      updateState({
        showNumpad: false,
        error: null,
        collection: data,
        submitting: false,
      })
    }).catch(async (err) => {
      console.log(err);
      updateState({
        servicePoint: null,
        showNumpad: false,
        error: translation.orderPlacingError[lang],
        submitting: false,
      })
    })
  }

  return (
    <form key={state.variation} className="first-screen-inputs" onSubmit={e => {e.preventDefault();}}>
      <Grid container spacing={3} justify="center" alignItems="flex-start">
        <Grid item md={7} sm={12} className="inputs-wrapper">
          <Grid container spacing={3} justify="flex-start" alignItems="center">
            <Grid item xs={12}>
              <h1 className="inputs-wrapper-title">{state.collection ? translation.orderPlaced[lang] : translation.fillLocationCode[lang]}</h1>
            </Grid>
          </Grid>
          <Number
            onChange={onChange}
            label={translation.locationCode[lang]}
            placeholder={'Click to enter the code'}
            decimal={false}
            negative={false}
            position="top"
            sync={true}
            inline={true}
            show={state.showNumpad && !state.loading}
            loading={state.loading}
            leadingZeros={true}
          />
          { (state.error && !state.loading) &&
          <Grid container spacing={3} justify="flex-start" alignItems="center">
            <Grid item xs={12}>
              <ShowError error={state.error} />
            </Grid>
          </Grid>
          }

          { (state.servicePoint && !state.loading) &&
          <Grid container spacing={3} justify="flex-start" alignItems="center">
            <Grid item xs={12}>
              <ShowServicePoint point={state.servicePoint} />
            </Grid>
          </Grid>
          }

          {state.collection &&
            <Grid container spacing={3} justify="flex-start" alignItems="center">
              <Grid item xs={12}>
                <ShowCollection collection={state.collection} />
              </Grid>
            </Grid>
          }

          {(!state.showNumpad && !state.loading) &&
            <Grid container spacing={3} justify="flex-start" alignItems="center">
              <Grid item xs={12}>
                <a href="#" className="service-point-clear service-point-info" onClick={clear}>{state.code ? translation.orEnterNewCode[lang] : translation.enterNewCode[lang]}</a>
              </Grid>
            </Grid>
          }

          { (state.code && !state.loading && !state.collection) &&
          <div className="service-point-info service-point-actions">
            <Button
              color="blue"
              onClick={ () => placeOrder() }
              submitting={state.submitting}
              className="checked"
            >{ translation.placeOrder[lang] }
            </Button>
          </div>
          }
        </Grid>
        <Grid item md={5} sm={12}>
          <HomeBanner version={ 1 } />
        </Grid>
      </Grid>
    </form>
  )
}

const mapStateToProps = ({ webView, userLocation, userData, notification }) => ({
  wv: webView,
  userLocation,
  userData,
  notification
});

const mapDispatchToProps = dispatch => {
  return {
    setOrderScreen: data => dispatch(setOrderScreen(data)),
    setFormattedAddress: data => dispatch(setFormattedAddress(data)),
    setUserLocation: data => dispatch(setUserLocation(data)),
    addUserData: data => dispatch(addUserData(data)),
    setNotificationData: data => dispatch(setNotificationData(data)),
    setUserData: data => dispatch(setUserData(data)),
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(FirstOrderScreen);
